import { styled } from "styled-components";
// import { devices } from '../../Constants';

export const AddproductWrapper = styled.div`
	padding: 50px 24px;
	margin-bottom: 30px;
	border: 1px solid #b8c8cf;
	box-shadow: 0px 10px 50px rgba(0, 103, 112, 0.05);
	border-radius: 10px;
	box-sizing: border-box;
	width: 100%;

	main {
		display: flex;
		gap: 3rem;
		margin-top: 1rem;
		/* width: 100%; */
		/* border: 1px solid red; */
	}

	.LeftSection {
		/* width: 18%; */
		/* max-width: 20%; */
		width: 21%;
		box-shadow: 0px 10px 50px rgba(0, 103, 112, 0.05);
		align-self: start;
		max-width: 200px;

		.productDetails {
			padding: 0rem 1rem 2.4rem;
			margin-bottom: 30px;
			margin-top: 16px;
			border: 1px solid #b8c8cf;
			border-radius: 14px;
			position: relative;

			.buttons {
				margin-bottom: 0.8rem;
				display: relative;

				.absolute-prev {
					position: absolute;
					left: -.9rem;
					top: 10rem;
					background: #ffffff;
					border-radius: 50%;
				}
				.absolute-next {
					position: absolute;
					right: -.9rem;
					top: 10rem;
					border-radius: 50%;
					background: #ffffff;
				}
				/* display: flex;
				justify-content: space-between; */
				
				/* border: 1px solid red; */
			}

			input[type="file"] {
				color: transparent;
				width: 0;
				height: 0;
				display: none;
			}

			img {
				width: 100%;
				height: 15rem;
				object-fit: contain;
				cursor: pointer;
				mix-blend-mode: darken;
				word-wrap: break-word;
				transition: transform 0.2s;
				/* border: 1px solid red; */
			}

			img:hover {
				cursor: default;
				transform: scale(1.1);
			}

			.price {
				font-weight: bold;
				margin-top: 1rem;
				color: #11293b !important;
				font-size: 1.125rem;
			}

			.name {
				margin-top: 1rem;
				font-weight: 500;
				font-size: 1.125rem;
				word-wrap: break-word;
			}
		}
	}

	.productForm {
		width: 100%;
	}
`;

export const AddCategoriesWrapper = styled(AddproductWrapper)``;

export const Title = styled.h2`
	font-size: 1.2rem;
	font-weight: bold;
`;

export const AddButtonGroup = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;

	input[type="file"] {
		color: transparent;
		width: 0;
		height: 0;
		display: none;
	}

	img {
		mix-blend-mode: darken;
		object-fit: cover;
		border: 1px solid #b8c8cf;
	}
`;

export const AddButton = styled.button`
	background-color: #eeeeee;
	border-radius: 0.3rem;
	padding: 0.5rem;
	border: 1px solid white;
`;

export const MajorImportButton = styled(AddButton)`
	width: 100%;
	display: flex;
	justify-content: center;
	border: 1px solid white;
`;

export const ChangeButton = styled.button`
	display: flex;
	gap: 1rem;
	align-items: center;
	padding: 0.9rem;
	border: 1px solid rgba(0, 103, 112, 0.7);
	color: #003a50;
	margin-top: 4rem;
	border-radius: 1.5rem;
	font-weight: 500;
	font-size: 1.1rem;
	cursor: pointer;
`;
